/**
 * Constantes para estados de archivos y trámites
 */

// Estados de archivo individual
export const FILE_STATUS = {
  PENDING: 'pending', // Registro en BD sin archivo físico
  UPLOADING: 'uploading', // Upload en progreso (solo frontend)
  UPLOADED: 'uploaded', // Archivo nuevo subido en esta sesión
  EXISTING: 'existing', // Archivo que ya existía en BD
  DELETED: 'deleted', // Marcado para eliminación (reversible hasta submit)
  SUBMITED: 'submited', // Confirmado después del submit
  ERROR: 'error', // Error en upload
};

// Estados del trámite completo
export const TRAMITE_STATUS = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  SUBMITTED: 'submitted',
  DELETED: 'deleted',
  ERROR: 'error',
};

// Configuración de archivos
export const UPLOAD_CONFIG = {
  MAX_RETRIES: 3,
  INITIAL_RETRY_DELAY: 1000, // 1 segundo
  MAX_FILE_SIZE: 4 * 1024 * 1024, // 4MB
  MAX_FILE_SIZE_MB: 4, // 4MB
  MAX_FILES_PER_DOC: 3,
  ALLOWED_FORMATS: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  ALLOWED_EXTENSIONS: ['.pdf', '.jpg', '.jpeg', '.png'],
};

/**
 * Verifica si un estado de archivo es válido para submit
 * @param {string} status - Estado del archivo
 * @returns {boolean}
 */
export const isFileStatusValidForSubmit = (status) => {
  return status === FILE_STATUS.UPLOADED || status === FILE_STATUS.EXISTING;
};

/**
 * Verifica si un estado de archivo requiere acción del usuario
 * @param {string} status - Estado del archivo
 * @returns {boolean}
 */
export const isFileStatusActionable = (status) => {
  return status === FILE_STATUS.ERROR || status === FILE_STATUS.PENDING;
};
